import useInterfaceConfig from "@hooks/useInterfaceConfig";
import { Link, Typography, useTheme } from "@mui/material";

export const TerminosCondiciones = () => {
  const theme = useTheme();
  const interfaceConfig = useInterfaceConfig();

  return (
    <Typography textAlign={"center"} color={theme?.palette?.primary?.dark}>
      Al continuar estas aceptando nuestros{" "}
      <Link href={interfaceConfig.terminos_condiciones} target="_blank">
        <Typography component={"span"}>términos y condiciones</Typography>
      </Link>{" "}
      y{" "}
      <Link href={interfaceConfig.aviso_privacidad} target="_blank">
        <Typography component={"span"}>políticas de privacidad</Typography>
      </Link>
    </Typography>
  );
};
